export default ({ isRequired, name, label, style, id, srOnlyLabel }) => (
  <label
    htmlFor={name}
    id={id}
    className={`${isRequired ? 'cb-required' : ''} ${srOnlyLabel ? 'sr-only' : ''}`}
    style={style ? style : null}
  >
    {label}
  </label>
)
